import { Container, Grid } from '@material-ui/core'
import { FC, useEffect, useRef, useState } from 'react'
import SearchFormExternalProject from '../component/web/manageExternalProject/search/searchForm/SearchFormExternalProject'
import ResultExternalProject from '../component/web/manageExternalProject/search/searchResult/ResultExternalProject'
import SearchAccordion from '../control/accordion/SearchAccordion'
import useLoading from '../control/loading/useLoading'
import useTranslate from '../i18n/useTranslate'
import { ResultSearchType } from '../services/manageExternalProject/searchFormExternalProjectType'
import useManageExternalProject from '../services/manageExternalProject/useManageExternalProject'

const ExternalProject: FC<{}> = () => {
    const [data, setData] = useState<ResultSearchType[]>([])
    const { loadingOpen, loadingClose } = useLoading()
    const currentPageNoRef = useRef<number>(1)
    const keywordSearchRef = useRef<string>('')
    const sumResult = 10
    const allDataRef = useRef<number>(0)

    const { getData } = useManageExternalProject()

    const translate = useTranslate()

    const handleScroll = () => {
        const divSearch = document.getElementById('boxSearch')
        if (isBottom(divSearch)) {
            window.removeEventListener('scroll', handleScroll)
            handleScrollEnd()
            setTimeout(() => {
                window.addEventListener('scroll', handleScroll, { passive: true })
            }, 1000)
        }
    }

    const isBottom = (el: any) => {
        return (
            el.getBoundingClientRect().bottom - window.innerHeight * 0.01 <= window.innerHeight && window.scrollY !== 0
        )
    }

    const handleScrollEnd = () => {
        currentPageNoRef.current = currentPageNoRef.current + 1
        getList()
    }

    const getList = async (projectID?: number) => {
        const param = {
            pageNo: currentPageNoRef.current,
            pageSize: sumResult,
            keywordSearch: keywordSearchRef.current || null,
        }
        loadingOpen()
        const res = await getData(param)
        if (projectID) {
            const cloneAllData = [...data]
            const idxData = cloneAllData.findIndex((item) => item.projectID === projectID)
            cloneAllData.splice(idxData, 1)
            setData(cloneAllData)
        } else {
            setData((prev) => [...prev, ...res.data])
        }
        allDataRef.current = res.total
        loadingClose()
    }

    useEffect(() => {
        getList()
        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
    return (
        <Container maxWidth="lg">
            <Grid container spacing={2} id="boxSearch">
                <Grid item xs={12}>
                    <SearchAccordion title={translate.get('LABEL.EXTERNAL_PROJECT_MANAGEMENT')}>
                        <SearchFormExternalProject
                            setData={setData}
                            keywordSearchRef={keywordSearchRef}
                            currentPageNoRef={currentPageNoRef}
                            allData={allDataRef}
                        />
                    </SearchAccordion>
                </Grid>

                <ResultExternalProject data={data} allData={allDataRef.current} getList={getList} />
            </Grid>
        </Container>
    )
}

export default ExternalProject
